<template>
  
  <div v-redirect-if-no-permission:RESTRICTED_AREA>
    <loading-component :value="loading"/>
    <DataTable ref="dataTable" url="restricted-area" :fieldsHiddenMain="['deleted_at']" perPage="100" :titles="titles"
      :actionsExtraMain="actionsExtraMain" :formatter="formatter" :title="$t('maps.restrictedAreas.restrictedAreas')" />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import axios from "axios";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "RestrictedAreas",
  title() {
    return this.$t("maps.restrictedAreas.title");
  },

  components: { DataTable, LoadingComponent},
  data() {
    return {
      loading: false

    };
  },
  computed: {
    titles() {
      return {
        id: "#",
        name: this.$t("common.name"),
        polygon: this.$t("maps.restrictedAreas.polygon"),
        from: this.$t("common.from"),
        to: this.$t("common.to"),
        created_at: this.$t("maps.restrictedAreas.dateCreated"),
        updated_at: this.$t("maps.restrictedAreas.dateUpdated"),
      };
    },

    actionsExtraMain() {
      return {
        duplicate: {
          title: this.$t("maps.restrictedAreas.duplicate"),
          icon: "content_copy",
          action: (item) =>
            this.duplicateItem(item)
        },
        edit: {
          action: (item) =>
            this.$router.push({
              name: "RestrictedAreasEditor",
              params: { id: item.id },
            }),
        },
        add: {
          action: () =>
            this.$router.push({
              name: "RestrictedAreasAdder",
            }),
        },

      };
    },
    formatter() {
      return {
        polygon(polygon) {
          let smallest = Array(2).fill(Math.pow(2, 32));
          let biggest = Array(2).fill(-Math.pow(2, 32));
          for (let arr of polygon.coordinates[0]) {
            smallest[0] = Math.min(smallest[0], arr[0]);
            smallest[1] = Math.min(smallest[1], arr[1]);
            biggest[0] = Math.max(biggest[0], arr[0]);
            biggest[1] = Math.max(biggest[1], arr[1]);
          }
          return `
            <svg height="75" width="75" viewBox="-75 0 75 75">
              <polygon points="${polygon.coordinates[0]
              .map(
                (arr) =>
                  (-(biggest[0] - arr[0]) / (biggest[0] - smallest[0])) * 75 +
                  "," +
                  ((biggest[1] - arr[1]) / (biggest[1] - smallest[1])) * 75
              )
              .join(" ")}" style="fill:lime;stroke:purple;stroke-width:1;"/>
            </svg>
          `;
        },
        created_at(value) { return moment(value).format("DD-MM-YYYY  HH:mm"); },
        updated_at(value) { return moment(value).format("DD-MM-YYYY  HH:mm"); },
        from(value) { return moment(value).format("DD-MM-YYYY  HH:mm"); },
        to(value) { return moment(value).format("DD-MM-YYYY  HH:mm"); }

      };
    },
  },
  methods: {
    duplicateItem(item) {
      confirm(this.$t("maps.restrictedAreas.confirmDuplicate")) &&
        (() => {
          this.loading = true;
          axios
            .post("restricted-area-duplicate",{id: item.id})
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("maps.restrictedAreas.duplicated"), "green");
              this.$refs.dataTable.getData();
            })
            .catch(({ response }) => {
              if (response && response.data && response.data.message)
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("maps.restrictedAreas.errorHappened"),
                  "red"
                );
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })();
    }
  }
};
</script>

<style scoped></style>
